import React, { useState } from "react";
import PostEditor from "../components/PostEditor";

const CreatePost = () => {
    const [content, setContent] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log("Nội dung bài viết:", content);
        // Gửi content đến API backend (POST /posts)
    };

    return (
        <div>
            <PostEditor onChange={setContent} />
            <button onClick={handleSubmit}>Lưu Bài Viết</button>
        </div>
    );
};

export default CreatePost;